export default {
	'the-planned-visit': 'the planned visit',
	'planned-visit': 'Planned visit',
	all: 'All',
	'no-planned-visits-for-this-day': 'NO PLANNED VISITS FOR THIS DAY',
}